import PropTypes from 'prop-types'

const IconMobile = ({ style }) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" style={style}>
      <path fillRule="evenodd" clipRule="evenodd" d="M8.06435 18.6423L3.00649 10.9563C4.39733 9.30511 7.90619 7.97168 9.32881 9.84565C11.7314 13.1161 11.9601 13.2252 12.3927 12.6371C13.8649 10.2546 19.1693 0.430612 19.2259 0.349609H3.43677C1.77614 0.366745 -0.0465161 2.08728 0.00387634 4.12482L0 19.8877C0.0170559 21.5553 1.57922 23.6504 3.49104 23.6504L20.5423 23.6419C22.4541 23.6504 24 21.9673 23.9721 20.1346L24 4.49868C20.8346 10.1338 16.4714 18.5192 16.4621 18.5356C14.5758 21.8185 10.3405 21.7546 8.06435 18.6423Z" fill="white" fillOpacity="0.8"/>
    </svg>
  )
}

IconMobile.propTypes = {
  style: PropTypes.object,
}

export default IconMobile
